export class OccProfile
{
	occProfileId: number;
	occProfileDate: Date;
}
